<template>
    <div>
        <hr>
        <div v-if="this.$route.name == 'displayPage'">
        </div>
        <div v-else>
            <div>footer:{{this.$route.name}}</div>
            <div><h5>World Plan(e)t Alpha</h5></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GlobalFooter"
    }
</script>